<template>
    <div>
        <div class="treetitle">
            <div class="tree-header-left" >
                <el-form @submit.native.prevent="loadBellList()" style="padding-top: 8px; padding-bottom: 8px" :disabled="!appData.tenantAdminUser">
                    <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchCondition" class="object-search-select" style="width:550px;" clearable>
                        <el-select class="search-item" v-model="searchConditionType" slot="prepend" @change="handleChangeSearchConditionType()">
                            <el-option style="font-size:12px" value="name" :label="$t('message.item_bell_id')"></el-option>
                            <el-option style="font-size:12px" value="displayName" :label="$t('message.item_bell_display_name')"></el-option>
                            <el-option style="font-size:12px" value="targetGroup" :label="$t('message.item_bell_target_group_search_tab')"></el-option>
                            <el-option style="font-size:12px" value="authUser" :label="$t('message.item_bell_auth_user_search_tab')"></el-option>
                        </el-select>
                        <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"/>
                    </el-input>
                </el-form>
            </div>
        </div>
        <div style="height:calc(100vh - 228px);overflow-y:auto">
            <div class="foundObject-record" v-for="bell in cachedBellList[currentPage]"
                :class="{selected: selectedBellId === bell.id}"
                @click="handleBellClicked(bell)">
                <div class="foundObject">
                    <span style="padding-left:10px;vertical-align:middle">{{ bell.name }}</span>
                </div>
            </div>
            <div style="width:100%" v-if="total === 0" class="no-data-message">
                <td v-if="previousSearchCondition" style="display: inline-block" v-t="'message.info_bell_not_match'"></td>
                <td v-else style="display: inline-block" v-t="'message.info_bell_not_found'"></td>
            </div>
        </div>
        <div class="pagination-container" v-if="total !== 0">
            <el-button icon="el-icon-arrow-left" type="text" class="pagination-button" @click="prevClick"
                :disabled="currentPage <= 1"></el-button>
            <span> {{ currentPage }} / {{ totalPages }} </span>
            <el-button icon="el-icon-arrow-right" type="text" class="pagination-button" @click="nextClick"
                :disabled="currentPage >= totalPages"></el-button>
        </div>
    </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            show: true,
            loadDataOngoing: false,
            selectedBellId: null,
            searchConditionType: null,
            searchCondition: null,
            previousSearchConditionType: null,
            previousSearchCondition: null,
            loadingScreen: null,
            isError: false,
            currentPage: 1,
            pageSize: constants.BELL_PAGINATION_SIZE,
            cachedBellList: {},
            total: 0,
            lastTurningPageTime: 0,
        };
    },

    computed: {
        totalPages() {
            return Math.ceil(this.total / this.pageSize);
        },
    },

    props: {
        appData: Object,
    },

    created() {
        this.searchConditionType = "name";
        this.loadBellList();
    },

    updated() {
    },

    methods: {
        handleBellClicked(bell) {
            this.selectedBellId = bell.id;
            this.$emit('on-selectnode', bell)
        },
        handleChangeSearchConditionType() {
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        reload(resetSelect) {
            this.cachedBellList = {};
            this.currentPage = 1;
            this.total = 0;
            this.getBellList();
            if (resetSelect) {
                this.$emit('resetSelectedNode');
            }
        },
        resetSelectedBell() {
            this.selectedBellId = null;
        },
        loadBellList() {
            if (this.isError) {
                commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_error_once_need_reload"));
                return;
            }

            if (this.loadDataOngoing) {
                return;
            }

            if (this.searchConditionType !== this.previousSearchConditionType || this.searchCondition !== this.previousSearchCondition) {
                this.reload(true);
            }
        },
        async getBellList() {
            // check cache
            if (this.currentPage in this.cachedBellList) {
                return
            }
            this.loadDataOngoing = true;
            this.showLoadingScreen();
            const upperId = this.currentPage > 1 ? this.cachedBellList[this.currentPage - 1].slice(-1)[0].id : null
            let param = {conditionType: this.searchConditionType, condition: this.searchCondition, upperId};

            try {
                const res = await server.post("/getbelllist", param)
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (this.currentPage === 1) {
                            this.previousSearchConditionType = this.searchConditionType;
                            this.previousSearchCondition = this.searchCondition;
                            this.total = res.data.total
                        } else if (this.total !== res.data.total) {
                            // Reload when changing total number
                            commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_reload_bell_list"));
                            this.reload(true);
                            return;
                        }
                        this.$set(this.cachedBellList, this.currentPage, res.data.dataList)
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_access_denied"));
                        this.isError = true;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getbelllist").replace("{code}", res.data.status));
                        this.isError = true;
                        break;
                }
                this.loadDataOngoing = false;
                this.closeLoadingScreen();
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "loadBellList", e);
                this.isError = true;
                this.loadDataOngoing = false;
                this.closeLoadingScreen();
            }
        },
        prevClick() {
            this.handleCurrentPageChange(this.currentPage - 1)
        },
        nextClick() {
            this.handleCurrentPageChange(this.currentPage + 1)
        },
        handleCurrentPageChange(nextPage) {
            if (this.loadDataOngoing) return;

            // Prevent button mashing
            let currentTime = Date.now();
            if (currentTime - this.lastTurningPageTime < 500) {
                return;
            }
            this.lastTurningPageTime = currentTime;

            this.currentPage = nextPage;
            this.getBellList();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}

.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}
.el-tree-node__content {
    height: 40px !important;
}
.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}
.el-tree-node__expand-icon {
    padding: 28px !important;
}

</style>

<style scoped>
/* ::v-deep .el-pagination .el-select .el-input {
    width: 120px;
} */
.pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: medium;
}
.pagination-button {
    background-color: white;
    color: #333b48;
    font-size: 20px;
    margin: 0 5px;
}
.pagination-button:disabled {
    background-color: transparent;
    color: #c0c4cc;
    cursor: not-allowed;
}
.pagination-button:hover:not(:disabled) {
    background-color: transparent;
    color: #5171cb;
}
.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}
.tree-command-text:hover {
    opacity: 0.7;
}

button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}

.tree-header-left {
    text-align : right;
    vertical-align: middle;
    float: left;
}
.tree-header-right {
    text-align : right;
    vertical-align: middle;
    padding-right: 20px;
}

.treetitle {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 56px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
    min-width: 630px;
}
.modal-default-button {
  float: right;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.common-object-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}
.common-object-tree.el-tree {
    width: 100%;
    height: calc(100vh - 175px);
}
.foundObject-record.selected {
    background-color: #ecf1fa;
}
</style>
